import React from "react";
import { Clock } from "lucide-react";
import StatusBadge from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";

// Presentational appointment row. `actions`: [{label, status, testId}], onStatus(id,status)
export default function AppointmentItem({ appt, actions = [], onStatus, showMember = true, waiters = 0 }) {
  return (
    <div data-testid={`appointment-${appt.id}`} className="flex flex-col sm:flex-row sm:items-center gap-3 p-4 rounded-2xl bg-[#13131C] border border-[#222230]">
      <div className="flex items-center gap-2 sm:w-24">
        <Clock size={15} className="text-[#FF5500]" />
        <span className="font-mono font-bold text-white">{appt.start_time}</span>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-white truncate">{showMember ? appt.member_name : appt.service_name}</p>
        <p className="text-xs text-[#68687B] truncate">{appt.service_name} · {appt.trainer_name}</p>
      </div>
      {waiters > 0 && (
        <span data-testid={`waitlist-badge-${appt.id}`} className="text-[11px] font-semibold px-2 py-1 rounded-full bg-amber-500/10 text-amber-400 border border-amber-500/30 whitespace-nowrap">
          {waiters} bekleyen
        </span>
      )}
      <StatusBadge status={appt.status} />
      {actions.length > 0 && appt.status === "scheduled" && (
        <div className="flex gap-1.5 flex-wrap">
          {actions.map((a) => (
            <Button key={a.status} size="sm" variant="secondary" onClick={() => onStatus(appt.id, a.status)}
              data-testid={`${a.testId}-${appt.id}`}
              className="h-8 bg-[#1C1C28] hover:bg-[#252536] text-white border border-[#2D2D3F] text-xs">
              {a.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}
